var render = function render(){var _vm=this,_c=_vm._self._c;return _c('custom-select',_vm._b({ref:"select",attrs:{"value":_vm.value,"type":"tree","url":"NationRegionTree","props":_vm.cascaderProps,"dataFilter":_vm.dataFilter},on:{"input":_vm.onInput,"getList":function($event){_vm.addressList = $event}}},'custom-select',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }